import { useState } from "react"
const { translatorServiceURL } = require("services/config")

const HEADERS = {
  "Content-Type": "application/json",
}

const METHODS = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
}

const AVALIALBE_LANGUAGES = [
  {
    languageId: 33,
    name: "العربية",
    code: "ar",
    label: "Arabic: العربية",
    isActive: true,
  },
  {
    languageId: 34,
    name: "বাংলা",
    code: "bn",
    label: "Bengali: বাংলা",
    isActive: true,
  },
  {
    languageId: 25,
    name: "Български",
    code: "bg",
    label: "Bulgarian: Български",
    isActive: true,
  },
  {
    languageId: 4,
    name: "简体中文",
    code: "zh-Hans",
    label: "Chinese (Simplified): 简体中文",
    isActive: true,
  },
  {
    languageId: 5,
    name: "繁體中文",
    code: "zh-CN",
    label: "Chinese (Traditional): 繁體中文",
    isActive: true,
  },
  {
    languageId: 23,
    name: "Čeština",
    code: "cs",
    label: "Czech: Čeština",
    isActive: true,
  },
  {
    languageId: 24,
    name: "Dansk",
    code: "da",
    label: "Danish: Dansk",
    isActive: true,
  },
  {
    languageId: 16,
    name: "Nederlands",
    code: "nl",
    label: "Dutch: Nederlands",
    isActive: true,
  },
  {
    languageId: 2,
    name: "English",
    code: "en-US",
    label: "English",
    isActive: true,
  },
  {
    languageId: 1,
    name: "Español",
    code: "es-MX",
    label: "Español",
    isActive: true,
  },
  {
    languageId: 17,
    name: "Eesti",
    code: "et",
    label: "Estonian: Eesti",
    isActive: true,
  },
  {
    languageId: 45,
    name: "فارسی",
    code: "fa",
    label: "Farsi: فارسی",
    isActive: true,
  },
  {
    languageId: 18,
    name: "Suomi",
    code: "fi",
    label: "Finnish: Suomi",
    isActive: true,
  },
  {
    languageId: 3,
    name: "Français",
    code: "fr-FR",
    label: "Français",
    isActive: true,
  },
  {
    languageId: 28,
    name: "Deutsch",
    code: "de",
    label: "German: Deutsch",
    isActive: true,
  },
  {
    languageId: 19,
    name: "Ελληνικά",
    code: "el",
    label: "Greek: Ελληνικά",
    isActive: true,
  },
  {
    languageId: 35,
    name: "ગુજરાતી",
    code: "gu",
    label: "Gujarati: ગુજરાતી",
    isActive: true,
  },
  {
    languageId: 36,
    name: "हिन्दी",
    code: "hi",
    label: "Hindi: हिन्दी",
    isActive: true,
  },
  {
    languageId: 20,
    name: "Magyar",
    code: "hu",
    label: "Hungarian: Magyar",
    isActive: true,
  },
  {
    languageId: 21,
    name: "Bahasa Indonesia",
    code: "id",
    label: "Indonesian: Bahasa Indonesia",
    isActive: true,
  },
  {
    languageId: 26,
    name: "Italiano",
    code: "it",
    label: "Italian: Italiano",
    isActive: true,
  },
  {
    languageId: 29,
    name: "日本語",
    code: "ja",
    label: "Japanese: 日本語",
    isActive: true,
  },
  {
    languageId: 30,
    name: "한국어",
    code: "ko",
    label: "Korean: 한국어",
    isActive: true,
  },
  {
    languageId: 46,
    name: "Kurdî",
    code: "ku",
    label: "Kurdish: Kurdî",
    isActive: true,
  },
  {
    languageId: 22,
    name: "Latviešu",
    code: "lv",
    label: "Latvian: Latviešu",
    isActive: true,
  },
  {
    languageId: 13,
    name: "Lietuvių",
    code: "lt",
    label: "Lithuanian: Lietuvių",
    isActive: true,
  },
  {
    languageId: 14,
    name: "Norsk",
    code: "no",
    label: "Norwegian: Norsk",
    isActive: true,
  },
  {
    languageId: 47,
    name: "پښتو",
    code: "ps",
    label: "Pashto: پښتو",
    isActive: true,
  },
  {
    languageId: 15,
    name: "Polski",
    code: "pl",
    label: "Polish: Polski",
    isActive: true,
  },
  {
    languageId: 6,
    name: "Português (Brasil)",
    code: "pt-BR",
    label: "Português (Brasil)",
    isActive: true,
  },
  {
    languageId: 27,
    name: "Português",
    code: "pt-PT",
    label: "Portuguese: Português",
    isActive: true,
  },
  {
    languageId: 37,
    name: "ਪੰਜਾਬੀ",
    code: "pa",
    label: "Punjabi: ਪੰਜਾਬੀ",
    isActive: true,
  },
  {
    languageId: 8,
    name: "Română",
    code: "ro",
    label: "Romanian: Română",
    isActive: true,
  },
  {
    languageId: 31,
    name: "Русский",
    code: "ru",
    label: "Russian: Русский",
    isActive: true,
  },
  {
    languageId: 9,
    name: "Slovenčina",
    code: "sk",
    label: "Slovak: Slovenčina",
    isActive: true,
  },
  {
    languageId: 10,
    name: "Slovenščina",
    code: "sl",
    label: "Slovenian: Slovenščina",
    isActive: true,
  },
  {
    languageId: 38,
    name: "Soomaali",
    code: "so",
    label: "Somali: Soomaali",
    isActive: true,
  },
  {
    languageId: 11,
    name: "Svenska",
    code: "sv",
    label: "Swedish: Svenska",
    isActive: true,
  },
  {
    languageId: 39,
    name: "Tagalog",
    code: "fil",
    label: "Tagalog: Tagalog",
    isActive: true,
  },
  {
    languageId: 40,
    name: "தமிழ்",
    code: "ta",
    label: "Tamil: தமிழ்",
    isActive: true,
  },
  {
    languageId: 41,
    name: "తెలుగు",
    code: "te",
    label: "Telugu: తెలుగు",
    isActive: true,
  },
  {
    languageId: 12,
    name: "Türkçe",
    code: "tr",
    label: "Turkish: Türkçe",
    isActive: true,
  },
  {
    languageId: 32,
    name: "Українська",
    code: "uk",
    label: "Ukrainian: Українська",
    isActive: true,
  },
  {
    languageId: 42,
    name: "اردو",
    code: "ur",
    label: "Urdu: اردو",
    isActive: true,
  },
  {
    languageId: 43,
    name: "Tiếng Việt",
    code: "vi",
    label: "Vietnamese: Tiếng Việt",
    isActive: true,
  },
  {
    languageId: 44,
    name: "粵語",
    code: "zh-HK",
    label: "Yue (Cantonese): 粵語",
    isActive: true,
  },
]

const useApi = () => {
  const [isFetching, setIsFetching] = useState(false)

  const getLanguages = async () => {
    setIsFetching(true)
    const response = await fetch(`${translatorServiceURL}/languages`, {
      method: METHODS.GET,
      headers: HEADERS,
    })
    const results = await response.json()
    setIsFetching(false)
    return results || []
  }

  const translate = async ({ q, source, target }) => {
    setIsFetching(true)
    const isString = (value) => typeof value === "string"
    try {
      const response = await fetch(`${translatorServiceURL}/translate`, {
        method: METHODS.POST,
        headers: HEADERS,
        body: JSON.stringify({
          q,
          source: isString(source) ? source?.split("-")[0] : source,
          target: isString(target) ? target?.split("-")[0] : target,
        }),
      })
      const results = await response.json()
      setIsFetching(false)
      return results
    } catch (error) {
      setIsFetching(false)
      throw error
    }
  }

  const sortedLanguages = [...AVALIALBE_LANGUAGES].sort((a, b) =>
    a.name.localeCompare(b.name)
  )

  return {
    getLanguages,
    translate,
    AVALIALBE_LANGUAGES: sortedLanguages,
    isFetching,
  }
}

export default useApi
